import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import './MultiTextInputStyles.scss';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import TooltipWithPortal from '../../base/Tooltip/TooltipWithPortal';

export default function MultiTextInput(props) {
  const {
    inputProps = null,
    className = '',
    fieldState = {
      error: '',
      touched: false,
    },
    // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
    // nosemgrep
    controlId = `text-input-${Math.random() * 10000}`,
    addPlaceholder = false,
    placeholder = '',
    disabled = false,
    inputClassName = '',
    portalClassName = '',
    variant = '',
    withLabel = true,
    label = '',
  } = props;
  const {
    error,
    isTouched: touched,
  } = fieldState;

  const [inputValue, setInputValue] = useState('');
  const anchorElement = useRef(null);
  const inputRef = useRef(null);
  const isError = Boolean(error);
  const { onChange = () => {}, name = '', value } = inputProps;
  const selectedValue = typeof value !== 'undefined' && Array.isArray(value) ? value : [];

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      if (inputValue) {
        onChange({ target: { value: [...selectedValue, inputValue], name } });
      }
      setInputValue('');
    }
  };

  const handleBlur = () => {
    if (inputValue) {
      onChange({ target: { value: [...selectedValue, inputValue], name: inputProps.name } });
    }
    setInputValue('');
  };

  const onClear = () => {
    setInputValue('');
    inputProps.onChange({ target: { value: [], name: inputProps.name } });
  };

  const handleRemove = index => {
    const newValue = [...selectedValue];
    newValue.splice(index, 1);
    inputProps.onChange({ target: { value: newValue, name } });
  };

  const handleChangeText = event => {
    setInputValue(event.target.value);
  };
  const inputPlaceholder = selectedValue.join(', ');

  return (
    <div className={classNames('form-control-wrapper', className)}>
      <Dropdown
        usePortal
        disabled={disabled}
      >
        <Dropdown.Toggle className="select-toggle">
          <TextInput
            inputAfter={(
              <div className="multi-text-input-buttons">
                <Icons icon="close" customIcon className="close" onClick={onClear} />
                <div id={controlId} className="select-arrow-wrapper">
                  <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
                </div>
              </div>
            )}
            className={classNames('custom-select multi-text', { 'is-invalid': isError && touched }, inputClassName)}
            fieldState={fieldState}
            containerRef={anchorElement}
            inputProps={{
              name,
              onChange: handleChangeText,
              value: inputValue,
              ref: inputRef,
              onBlur: handleBlur,
              onKeyDown: handleKeyDown,
            }}
            placeholder={inputPlaceholder}
            withLabel={withLabel}
            label={label}
            variant={variant}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu key={selectedValue.length} useResizeContent={false} disableClickToggle rightPadding={32} className="select-options-wrapper" anchorElement={anchorElement} classNamePortal={classNames('portal-select-options', portalClassName)}>
          <div className="select-options-list">
            {addPlaceholder
              ? (
                <div
                  className={classNames('select-option')}
                  onClick={() => { onClear(); }}
                >
                  {placeholder || 'Очистить'}
                </div>
              )
              : null}
            {selectedValue.map((item, key) => (
              <div
                key={key}
                className={classNames('select-option multi-text-option')}
              >
                <div className="multi-text-item">
                  <div className="multi-text-item-content">
                    {item?.length > 25 ? (<TooltipWithPortal content={item} />) : item}
                  </div>
                  <div className="multi-text-item-icon" onClick={() => handleRemove(key)}>
                    <Icons icon="close" customIcon className="close" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
